<template>
  <div class="confirm">
    <!-- 标题栏 -->
    <van-nav-bar left-arrow title="个人信息" @click-left="onClickLeft" />
    <!-- 内容 -->
    <div class="page">
      <div class="login">
        <div class="login-title tl">
          更换手机后,下次登录可使用新手机号登录。当前手机号:{{personMobileNo}}
        </div>
        <div class="login-form">
          <div class="login-form-item">
            <input type="number" v-model="mobileNo" placeholder="手机号" />
          </div>
          <div class="login-form-item">
            <input type="number" v-model="mobileCode" placeholder="验证码" class="code" />
            <div class="verCode" @click="getBindCode">
              {{miaoShow}}
            </div>
          </div>
        </div>
        <div class="kqb-submit">
          <button @click='submitBindMobile' :class="[checkBind ? 'inputMobile':'']">确认更换</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
let miao = 60 // 倒计时
export default {
  name: 'confirm',
  data () {
    return {
      mobileNo: '',
      checkBind: false,
      mobileCode: '',
      isSendMobile: true,
      miaoShow: '获取验证码',
      personMobileNo: ''
    }
  },
  created () {
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    inputMobileCode: function (e) {
      var that = this
      var mobileNo = that.data.mobileNo
      var keywords = e.detail.value
      if (keywords.trim().length === 0) {
        that.setData({
          mobileCode: '',
          checkBind: false
        })
      } else {
        if (mobileNo.length >= 11 && keywords.length > 0) {
          that.setData({
            checkBind: true
          })
        } else {
          that.setData({
            checkBind: false
          })
        }
        that.setData({
          mobileCode: keywords
        })
      }
    },

    getBindCode: function () {
      var that = this
      var mobileNo = that.data.mobileNo
      var isSendMobile = that.data.isSendMobile
      if (mobileNo.length === 0) {
        Toast({
          title: '亲,请输入手机号码',
          icon: 'none',
          duration: 2000
        })
      } else if (mobileNo.length < 11) {
        Toast({
          title: '亲,你输入的手机号码长度少于11位',
          icon: 'none',
          duration: 2000
        })
      } else {
        if (isSendMobile) {
          // var params = app.getRequestParams()
          // params['mobileNo'] = mobileNo
          // var dataSign = app.dataSign(params)
          // params['dataSign'] = dataSign
          // wx.request({
          //   url: app.globalData.requestDomain + '/auth/person/info/send/bind/mobileCode', // 请求地址
          //   data: params,
          //   header: {// 请求头
          //     'Content-Type': 'application/x-www-form-urlencoded'
          //   },
          //   method: 'POST', // get为默认方法/POST
          //   success: function (result) {
          //     if (result.data.resultCode == 200 && result.data.success) {
          //       wx.showToast({
          //         title: '发送验证码成功',
          //         icon: 'none',
          //         duration: 2000
          //       })
          //       that.setData({
          //         isSendMobile: false
          //       })
          //       that.setTimeOutSendMobileCode()
          //     } else {
          //       app.requetServerError(result.data.resultMsg)
          //     }
          //   },
          //   fail: function (err) {
          //     app.requetError()
          //   }
          // })
        }
      }
    },

    setTimeOutSendMobileCode: function () {
      var that = this
      var interval = setInterval(function () {
        that.setData({
          isSendMobile: false,
          miaoShow: '' + miao + '秒重新获取'
        })
        if (miao === 0) {
          miao = 59
          clearInterval(interval)
          // var mobileNo = that.mobile
          // that.setData({
          //   isSendMobile: true,
          //   miaoShow: '获取验证码'
          // })
        }
        miao--
      }, 1000)
    },

    submitBindMobile: function () {
      var that = this
      var mobileNo = that.data.mobileNo
      var mobileCode = that.data.mobileCode
      if (mobileNo.trim().length >= 11 && mobileCode.trim().length > 0) {
        // var params = app.getRequestParams()
        // params['mobileNo'] = mobileNo
        // params['mobileCode'] = mobileCode
        // var dataSign = app.dataSign(params)
        // params['dataSign'] = dataSign
        // wx.request({
        //   url: app.globalData.requestDomain + '/auth/person/info/bind/mobileNo', // 请求地址
        //   data: params,
        //   header: {// 请求头
        //     'Content-Type': 'application/x-www-form-urlencoded'
        //   },
        //   method: 'POST', // get为默认方法/POST
        //   success: function (result) {
        //     if (result.data.resultCode == 200 && result.data.success) {
        //       app.globalData.personInfo.personAccountInfoMobileNo = mobileNo
        //       wx.navigateBack({
        //         delta: 2
        //       })
        //     } else {
        //       app.requetServerError(result.data.resultMsg)
        //     }
        //   },
        //   fail: function (err) {
        //     app.requetError()
        //   }
        // })
      }
    }
  }
}
</script>

<style lang="css" scoped>
.page {
  background: #fff;
}
input {
  border: 0;
  background: transparent;
}
.login {
  padding: 0 40px;
}

.login .login-title {
  padding: 36px 0 0 0;
  font-size: 30px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
}

.login .login-form {
  margin: 30px 0 30px 0;
  border-radius: 5px;
  overflow: hidden;
  background: #f8fbff;
}

.login .login-form input {
  position: relative;
  height: 88px;
  line-height: 88px;
  padding: 0 30px;
  font-size: 32px;
  background-color: #f8fbff;
}

.login .login-form .login-form-item {
  border-top: 1px solid #e6e6e6;
}

.login .login-form .login-form-item:first-child {
  border-top: 0;
}

.login .login-form .login-form-item:first-child input::after {
  border-bottom: 0;
}

/* .login .login-form .login-form-item:first-child input {
  padding-left: 128px;
} */

.login .login-form .login-form-item:first-child::after {
  content: "+86";
  position: absolute;
  left: 30px;
  top: 28px;
}

.login .login-form .login-form-item:first-child input::before {
  content: "";
  position: absolute;
  top: 30px;
  bottom: 0;
  left: 116px;
  border: none;
  border-left: 1px solid #e6e6e6;
  transform: scaleY(0.5);
  transform-origin: 0 0;
}

.login .login-form .login-form-item input.code {
  padding-right: 200px;
}

.login-form-item .verCode {
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 32px;
  color: #829abc;
  z-index: 1;
}

.kqb-submit {
  position: relative;
}

.kqb-submit button {
  width: 100%;
  height: 88px;
  line-height: 88px;
  border-radius: 5px;
  font-size: 32px;
  color: #fff;
  background-color: #ffd1d4;
}

.kqb-submit button.inputMobile {
  background-color: #f82e3d;
}
</style>
